import { render } from "./TrocarNivelTurma.vue?vue&type=template&id=311ada9a&scoped=true"
import script from "./TrocarNivelTurma.vue?vue&type=script&lang=js"
export * from "./TrocarNivelTurma.vue?vue&type=script&lang=js"

import "./TrocarNivelTurma.vue?vue&type=style&index=0&id=311ada9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311ada9a"]])

export default __exports__